import React,
       {useState, useEffect, useRef     }   from "react";
import { useNavigate                    }   from "react-router-dom";
import {useLoader                       }   from "components/Covers/loadingCover";
import {useActionModal                  }   from "components/Covers/confirmAction";
import {useInfoMsgModal                 }   from "components/Covers/infoMessageModal";
import {useToastMessage                 }   from "components/Covers/toastMessage";
import {InputGeneral, InputPassword     }   from "components/Field/field";
import MainStyle                            from "components/UI/main.module.scss";
import {
        changePassword,
        changeSelfData,
        getSelfData,
                                        }   from "./userConfigService";
import { getImgSrc, 
         imageToBase64, 
         q3x_FunData,
         qU3R0_FunData,
         q3k_Reigan,
         DefaultLoadingLogo,
         Heimdall, 
         GetLabel                       }   from "Utilities/utils";

let blank_user_obj = {
    FIRST_NAME:     "",
    LAST_NAME:      "",
    PASS:           "",
    PASSC:          "",
    FILE_ID:        0,
    FILE_DESC:      "",
    FILE_DATA:      "",
    FILE_B64:       ""
};
let appLang = null;

const Avatar = () => {
    return (
        <>
            <svg viewBox="0 -5 66 66" xmlns="http://www.w3.org/2000/svg" style={{ backgroundColor: '#f0f0f0', width: '100%', height: '100%'}}>
                <circle className={MainStyle.avatar_head} cx="32" cy="22" r="12" fill="#707070"/>
                <path d="M32 36c-9 0-20 6-20 14v14h40V50c0-8-11-14-20-14z" fill="#707070"/>
                <ellipse className={MainStyle.avatar_eye_left} cx="27" cy="20" rx="2" ry="2" fill="#fff"/>
                <ellipse className={MainStyle.avatar_eye_right} cx="37" cy="20" rx="2" ry="2" fill="#fff"/>
            </svg>
        </>
    );
};

const DivisionBlock = () => {
    return(
        <>
            <div className={[MainStyle.py_2].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_1}/>
                    <div className={[MainStyle.col_lg_10, MainStyle.border_bottom].join(" ")}/>
                    <div className={MainStyle.col_lg_1}/>
                </div>
            </div>
        </>
    );
};

const DefaultPadding = () =>{
    return(
        <>
            <div className={MainStyle.py_3}/>
        </>
    );
}

const PassWordChange = ({prop, setProp, setDisplay, ...other}) => {
    const navigate                    = useNavigate();
    const { showActionMessage       } = useActionModal(); // Modal message + action control     
    const { showLoader, 
            hideLoader,
            showInfoMessage         } = other;
    const [isValid,     setIsValid  ] = useState(true);

    function validateRecord() {
        if (    prop.PASS        != ""  && 
                prop.PASS.length >  8   &&
                prop.PASS.length <  35  &&
                prop.PASSC       != ""  &&
                prop.PASSC.length > 8   &&
                prop.PASSC.length < 35  &&                                    
                q3k_Reigan(prop.PASS)   &&  
                q3k_Reigan(prop.PASSC)     ) {
                    return true;
        }
        else {
            return false;

        }
    }
    function changePass() {
        if (validateRecord()) {
            showActionMessage({ header: GetLabel(appLang, 54), 
                                message: <>{GetLabel(appLang, 337)}<br/>{GetLabel(appLang, 338)}</> },
                                { confirm_action: async () => {
                                        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                                        let fetchedData = await changePassword(prop);
                                        if (fetchedData) {
                                            if (fetchedData?.status?.statusCode == 0) {
                                                hideLoader();
                                                localStorage.removeItem("charlore");
                                                localStorage.removeItem("holocron");
                                                navigate("/login");
                                            }
                                            else {
                                                hideLoader();
                                                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                                            }
                                        }
                                    }
                                }
            );  
        }
        else {
            showInfoMessage({header: GetLabel(appLang, 107), message: GetLabel(appLang, 339)});
        }      
    }
    function cancelAction() {
        setProp({ PASS: "", PASSC: "" });
        setDisplay(0);
        return;
    }
    function handlePChange(origin, e) {
        if (origin === 1) {
            setProp({PASS: e  });
        } else {
            setProp({PASSC: e });
        }
    }

    useEffect(() => {
        if (prop.PASS && prop.PASSC) {
            setIsValid(prop.PASS === prop.PASSC);
        } else {
            setIsValid(true);
        }
    }, [prop.PASS, prop.PASSC]);

    return (
        <>
            {/*     label instruction      */}
            <div className={[MainStyle.row, MainStyle.my_3].join(" ")}>
                <div className={MainStyle.col}/>
                <div className={MainStyle.col_lg_9}>
                    <div className={[MainStyle.mx_3, MainStyle.bg_warning, MainStyle.rounded_2, MainStyle.border_1, MainStyle.shadow_sm].join(" ")}>
                        <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                            <span className={[MainStyle.fs_6,
                                            MainStyle.text_black,
                                            MainStyle.fw_semibold
                                            ].join(" ")}
                            >
                                {GetLabel(appLang, 340)}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/*     pass               */}
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_3}>
                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                        <span className={[MainStyle.fs_6,
                                        MainStyle.text_body,
                                        MainStyle.fw_semibold
                                        ].join(" ")}
                        >
                            {GetLabel(appLang, 341)}:
                        </span>
                    </div>
                </div>
                <div className={MainStyle.col_lg_9}>
                    <div className={MainStyle.mx_3}>
                        <InputPassword 
                          value={prop.PASS}
                          type={"password"}
                          className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                          onChange={(event) => handlePChange(1, qU3R0_FunData(event.target.value))}
                          placeholder={GetLabel(appLang, 94)}
                          maxLength={35}
                          icon_style={MainStyle.btnEyePassword}
                          icon_style_hover={MainStyle.btnEyePasswordHover}
                        >
                        </InputPassword>
                        <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop.PASS.length} {GetLabel(appLang, 44)} 35 {GetLabel(appLang, 45)}.</span>
                    </div>
                </div>
            </div>
                                    
            {/*     pass confirmation  */}
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_3}>
                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                        <span className={[MainStyle.fs_6,
                                        MainStyle.text_body,
                                        MainStyle.fw_semibold
                                        ].join(" ")}
                        >
                            {GetLabel(appLang, 342)}:
                        </span>
                    </div>
                </div>
                <div className={MainStyle.col_lg_9}>
                    <div className={MainStyle.mx_3}>
                        <InputPassword 
                          value={prop.PASSC}
                          type={"password"}
                          className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                          onChange={(event) => handlePChange(2, qU3R0_FunData(event.target.value))}
                          placeholder={GetLabel(appLang, 94)}
                          maxLength={35}
                          icon_style={MainStyle.btnEyePassword}
                          icon_style_hover={MainStyle.btnEyePasswordHover}
                        >
                        </InputPassword>
                        <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop.PASSC.length} {GetLabel(appLang, 44)} 35 {GetLabel(appLang, 45)}.</span>
                        {!isValid && (            
                            <p className={[MainStyle.fs_7, MainStyle.text_danger, MainStyle.fw_semibold].join(" ")}>
                                {GetLabel(appLang, 343)}
                            </p>
                        )}
                    </div>
                </div>
            </div>
            
            <DefaultPadding/>

            {/*   Confirm or Cancel    */}
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_2}/>
                <div className={MainStyle.col_lg_2}>
                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3].join(" ")}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_vanilla,                                                             MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.py_3,
                                        MainStyle.px_5,
                                        MainStyle.mx_3,
                                        MainStyle.rounded_3].join(" ")}
                            onClick={() => {changePass()}}
                        >
                            {GetLabel(appLang, 52)}
                        </button>
                    </div>
                </div>
                <div className={MainStyle.col_lg}/>
                <div className={MainStyle.col_lg_2}>
                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3].join(" ")}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_vanilla,                                                             MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.py_3,
                                        MainStyle.px_5,
                                        MainStyle.mx_3,
                                        MainStyle.rounded_3].join(" ")}
                            onClick={() => {cancelAction()}}
                        >
                            {GetLabel(appLang, 53)}
                        </button>
                    </div>
                </div>
                <div className={MainStyle.col_lg_2}/>
            </div>
        </>
    );
}

export const UserConfigPage = () => {
    const { showLoader, hideLoader  }       = useLoader();                // Control over the loader
    const { showInfoMessage         }       = useInfoMsgModal();          // Modal message control 
    const { showActionMessage       }       = useActionModal();           // Modal message + action control     
    const { showToastMessage        }       = useToastMessage();          // Toast message display          
    const [userObj,     setUserObj  ]       = useState(blank_user_obj);   // User Object
    const fileInputRef                      = useRef(null);               // File input ref
    const [dPassChange, setDPassChange  ]   = useState(0);                // Control over display password change


    function validateRecord(obj) {
        let passed = true;
        if (obj.FIRST_NAME === ""){
            passed = false;
        }
        return (passed);
    }

    const handleSave = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await changeSelfData(userObj);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleChange = (updatedValues) => {
        setUserObj(prevState => ({
            ...prevState,
            ...updatedValues
        }));
    };

    const BtnSave = () => {
        if (validateRecord(userObj)) {
            showActionMessage({ header: GetLabel(appLang, 54), 
                message: <>{GetLabel(appLang, 50)}<br/>{GetLabel(appLang, 51)}</> },
              { confirm_action: () => handleSave()}
            );   
            return;
        }
        else {
            showInfoMessage({header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 185)}<br/>{GetLabel(appLang, 344)}<br/>{GetLabel(appLang, 345)}</>});
            return;
        }

        
    };

    const BtnUpload = async (event) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            try {
                const blob = URL.createObjectURL(file);
                const base64Image = await imageToBase64(blob);
                
                handleChange({FILE_B64: base64Image});

                // Reset input 
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }

            } catch (error) {
                //console.error('Error converting to base64:', error);
            }
        }
    };
    
    const BtnRemovePhoto = () => {
        try {
            if (userObj.FILE_ID > 0) {
                handleChange({FILE_ID: 0, FILE_DESC: "", FILE_B64: "", FILE_DATA: ""});
            }
            else {
                handleChange({FILE_B64: ""});
            }

        } catch (error) {
            //console.error('Error trying to remove the referenced file:', error);
        }
    };
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getSelfData();
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;
                            setUserObj(fetchedData);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }                        
            } 
            catch (error) {
                setUserObj(blank_user_obj);
            }
        };
        fetchData();
    }, []);
    
    return (
        <>
            <DefaultPadding/>
            <div className={[MainStyle.m_3].join(" ")}>
            <div className={[MainStyle.bg_card, 
                             MainStyle.shadow, 
                             MainStyle.border, 
                             MainStyle.rounded].join(" ")}>
                <div className={[MainStyle.m_3].join(" ")}>
                    <span className={[MainStyle.fs_5, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                        {GetLabel(appLang, 41)}
                    </span>
                </div>

                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>
                    
                    <DefaultPadding/>

                    <div className={MainStyle.row}>
                        {/*     User Data Configuration    */}
                        <div className={MainStyle.col_lg_7}>
                            
                            {/*     first name  + last name */}
                            {Heimdall([20]) && (
                                <React.Fragment>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg_3}>
                                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                                <span className={[MainStyle.fs_6,
                                                                MainStyle.text_body,
                                                                MainStyle.fw_semibold
                                                                ].join(" ")}
                                                >
                                                    {GetLabel(appLang, 42)}*:
                                                </span>
                                            </div>
                                        </div>
                                        <div className={MainStyle.col_lg_9}>
                                            <div className={MainStyle.mx_3}>
                                                <InputGeneral 
                                                    value={userObj.FIRST_NAME}
                                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                    onChange={(event) => handleChange({ FIRST_NAME: q3x_FunData(event.target.value) })}
                                                    placeholder={GetLabel(appLang, 346)}
                                                    maxLength={50}
                                                />
                                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{userObj.FIRST_NAME.length} {GetLabel(appLang, 44)} 50 {GetLabel(appLang, 45)}.</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg_3}>
                                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                                <span className={[MainStyle.fs_6,
                                                                MainStyle.text_body,
                                                                MainStyle.fw_semibold
                                                                ].join(" ")}
                                                >
                                                    {GetLabel(appLang, 43)}:
                                                </span>
                                            </div>
                                        </div>
                                        <div className={MainStyle.col_lg_9}>
                                            <div className={MainStyle.mx_3}>
                                                <InputGeneral 
                                                    value={userObj.LAST_NAME}
                                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                    onChange={(event) => handleChange({ LAST_NAME: q3x_FunData(event.target.value) })}
                                                    placeholder={GetLabel(appLang, 43)}
                                                    maxLength={150}
                                                    autoSize={true}
                                                />
                                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{userObj.LAST_NAME.length} {GetLabel(appLang, 44)} 150 {GetLabel(appLang, 45)}.</span>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}

                            {
                                dPassChange === 0?                                     
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}/>
                                        <div className={MainStyle.col_lg_3}>
                                            <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3].join(" ")}>
                                                <button
                                                    style={{width: '100%'}}
                                                    className={[MainStyle.btn_vanilla,                                                             MainStyle.rounded_3, 
                                                                MainStyle.border, 
                                                                MainStyle.shadow_sm, 
                                                                MainStyle.fs_6,
                                                                MainStyle.py_3,
                                                                MainStyle.px_5,
                                                                MainStyle.mx_3,
                                                                MainStyle.rounded_3].join(" ")}
                                                    onClick={() => {setDPassChange(1)}}
                                                >
                                                    {GetLabel(appLang, 46)}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                :
                                    <PassWordChange 
                                        prop={userObj} 
                                        setProp={handleChange} 
                                        setDisplay={setDPassChange}
                                        showLoader={showLoader}
                                        hideLoader={hideLoader}
                                        showInfoMessage={showInfoMessage}
                                    />
                            }

                        </div>

                        {/*     Photo Selection            */}
                        {Heimdall([20]) && (
                            <div className={MainStyle.col_lg_5}>
                                <div className={[ MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3,  MainStyle.mx_3].join(" ")}>
                                    <span className={[  MainStyle.fs_7,
                                                        MainStyle.text_body_faded,
                                                        MainStyle.fw_semibold].join(" ")}
                                    >
                                        {GetLabel(appLang, 47)}
                                    </span>
                                </div>
                                <div className={[MainStyle.mx_5].join(" ")}>
                                        <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.my_3].join(" ")}>                                        
                                            <div 
                                                    style={{overflowX: 'hidden', overflowY: 'hidden', width: '15rem', height: '15rem'}}
                                                    className={[MainStyle.border,
                                                                MainStyle.shadow, 
                                                                MainStyle.rounded_circle].join(" ")} 
                                            >
                                                {userObj.FILE_ID != 0 ?
                                                    userObj.FILE_B64 != "" ?
                                                            <img src={`data:image/png;base64, ${userObj.FILE_B64}`} style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}/>
                                                        :
                                                    userObj.FILE_DATA != "" &&  userObj.FILE_DATA  != null?
                                                            <img src={getImgSrc(userObj.FILE_DATA)} style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}/>
                                                        :
                                                    <Avatar/>

                                                :
                                                    userObj.FILE_B64 != "" ?
                                                        <img src={`data:image/png;base64, ${userObj.FILE_B64}`} style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}/>
                                                    :

                                                        <Avatar/>
                                                }
                                            </div>
                                        </div>
                                        <div className={MainStyle.row}>
                                            <div className={MainStyle.col_lg_1}></div>
                                            {
                                                (userObj.FILE_DATA != "" && userObj.FILE_ID != 0) || userObj.FILE_B64 != "" ?
                                                <>
                                                <div className={MainStyle.col_lg_5}>
                                                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3].join(" ")}>
                                                        <button
                                                            style={{width: '100%'}}
                                                            className={[MainStyle.btn_delete,                                                             MainStyle.rounded_3, 
                                                                        MainStyle.border, 
                                                                        MainStyle.shadow_sm, 
                                                                        MainStyle.fs_6,
                                                                        MainStyle.py_3,
                                                                        MainStyle.px_5,
                                                                        MainStyle.mx_3,
                                                                        MainStyle.rounded_3].join(" ")}
                                                            onClick={BtnRemovePhoto}
                                                        >
                                                            {GetLabel(appLang, 153)}
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className={MainStyle.col_lg_5}>
                                                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3].join(" ")}>
                                                        <label 
                                                            htmlFor="file-upload" 
                                                            style={{ display: 'inline-block', width: '100%', paddingTop: "0.77rem", paddingBottom: "0.77rem" }}
                                                            className={[MainStyle.text_center,
                                                                        MainStyle.btn_blue, 
                                                                        MainStyle.border, 
                                                                        MainStyle.shadow_sm, 
                                                                        MainStyle.fs_6,
                                                                        MainStyle.text_white,
                                                                        MainStyle.px_5,
                                                                        MainStyle.mx_3,
                                                                        MainStyle.rounded_3].join(" ")} 
                                                        >
                                                            {GetLabel(appLang, 48)}
                                                        </label>
                                                        <input
                                                            id="file-upload"
                                                            type="file"
                                                            style={{ display: 'none'}}
                                                            ref={fileInputRef}
                                                            onChange={BtnUpload}
                                                        />
                                                    </div>
                                                </div>
                                                </>
                                            :
                                                <>
                                                <div className={MainStyle.col_lg_10}>
                                                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                                        <label 
                                                            htmlFor="file-upload" 
                                                            className={[MainStyle.btn_blue, 
                                                                        MainStyle.rounded_3, 
                                                                        MainStyle.border, 
                                                                        MainStyle.shadow_sm, 
                                                                        MainStyle.fs_6,
                                                                        MainStyle.text_white,
                                                                        MainStyle.py_3,
                                                                        MainStyle.px_5,
                                                                        MainStyle.mx_3].join(" ")} 
                                                        >
                                                            {GetLabel(appLang, 48)}
                                                        </label>
                                                        <input
                                                            id="file-upload"
                                                            type="file"
                                                            style={{ display: 'none' }}
                                                            ref={fileInputRef}
                                                            onChange={BtnUpload}
                                                        />
                                                    </div>
                                                </div>
                                                </>
                                            }
                                            <div className={MainStyle.col_lg_1}></div>
                                        </div>
                                </div>
                            </div>
                        )}


                        <DefaultPadding/>


                    </div>

                </div>
                
                <div className={MainStyle.my_5}/>

            </div>




                {/*
                    --------------------------------------------------------------------------
                                                    CLICK ACTION
                    --------------------------------------------------------------------------
                */}
                {Heimdall([20]) && (
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_10}></div>
                        <div className={MainStyle.col_lg_2}>
                            <div className={[MainStyle.mt_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_green, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.text_white,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={BtnSave}
                                >
                                    {GetLabel(appLang, 49)}
                                </button>
                            </div>
                        </div>
                    </div>
                )}        
                {/*--------------------------------------------------------------------------*/}                                    
            
            
            
            </div>
        </>
    );
};